import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthContext";
import { Home, ChefHat, BookOpen, Camera, Heart, MoreHorizontal, Settings, LogOut } from "lucide-react";
import glucofyLogo from "@/assets/glucofy-logo.png";
import s from "@/pages/Inicio.module.css";

// Global desktop sidebar (hidden below 900px via .sidebar in Inicio.module.css —
// the same CSS Module this was extracted from, so the look stays identical).
// Meal Plan intentionally excluded per standing product decision.
const SIDEBAR_ITEMS = [
  { key: "home", icon: Home, path: "/home" },
  { key: "recipes", icon: ChefHat, path: "/recipes" },
  { key: "my-content", icon: BookOpen, path: "/my-content" },
  { key: "glucophoto", icon: Camera, path: "/glucophoto" },
  { key: "favorites", icon: Heart, path: "/saved-recipes" },
  { key: "more", icon: MoreHorizontal, path: "/more" },
];

const DesktopSidebar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();
  const p = location.pathname;

  const isActive = (path: string) => {
    if (path === "/home") return p === "/" || p === "/home";
    return p === path || p.startsWith(path + "/");
  };

  const items = SIDEBAR_ITEMS.map((item) => ({
    ...item,
    label:
      item.key === "glucophoto"
        ? "GlucoPhoto"
        : item.key === "home"
          ? t("nav.home", "Home")
          : item.key === "recipes"
            ? t("nav.recipes", "Recipes")
            : item.key === "my-content"
              ? t("home.your_contents", "My Content")
              : item.key === "favorites"
                ? t("home.your_favorites", "Favorites")
                : t("nav.more", "More"),
  }));

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <aside className={s.sidebar}>
      <div className={s.logo} style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <img src={glucofyLogo} alt="Glucofy" height={28} width={28} style={{ objectFit: "contain" }} />
        <span>Glucofy</span>
      </div>

      {items.map((item) => (
        <button
          key={item.key}
          onClick={() => navigate(item.path)}
          className={`${s.navItem} ${isActive(item.path) ? s.navItemActive : ""}`}
        >
          <item.icon size={18} /> {item.label}
        </button>
      ))}

      <div className={s.sidebarFooter}>
        <button onClick={() => navigate("/settings")} className={s.navItem}>
          <Settings size={18} /> {t("more.settings", "Settings")}
        </button>
        <button onClick={handleLogout} className={s.navItem} style={{ color: "#c0392b" }}>
          <LogOut size={18} /> {t("profile.logout", "Sign out")}
        </button>
      </div>
    </aside>
  );
};

export default DesktopSidebar;
